import { createContext } from 'react';

const MoviesContext = createContext(null);

export default MoviesContext;
